import { render, staticRenderFns } from "./TestDayControls.vue?vue&type=template&id=03155f83&scoped=true"
import script from "./TestDayControls.vue?vue&type=script&lang=js"
export * from "./TestDayControls.vue?vue&type=script&lang=js"
import style0 from "./TestDayControls.vue?vue&type=style&index=0&id=03155f83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03155f83",
  null
  
)

export default component.exports